const anyAccountSelected = accountSettings =>
  accountSettings && Object.values(accountSettings).some(channel => channel.value.length > 0);

const noChannelSelected = (laymanMode, availableChannels, accountSettings, type) =>
  laymanMode ? availableChannels[type].length === 0 : !anyAccountSelected(accountSettings);

export default noChannelSelected;
